import { render, staticRenderFns } from "./proposal-edit.vue?vue&type=template&id=9f30f1a6&scoped=true&"
import script from "./proposal-edit.vue?vue&type=script&lang=ts&"
export * from "./proposal-edit.vue?vue&type=script&lang=ts&"
import style0 from "./proposal-edit.vue?vue&type=style&index=0&id=9f30f1a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f30f1a6",
  null
  
)

export default component.exports